import { useState, useEffect } from "react";

const NuevoMensaje = ({ dni, onClose, onEnviar }) => {
  
  const [mensaje, setMensaje] = useState("");

  const handleEnviar = () => {
    if (mensaje.trim() === "") return;
    onEnviar({ dni, mensaje });
    setMensaje("");
    onClose();
  };

  return (
    <div className="accesos-directos-tarjeta historico-seguimiento solicita-cita">
      <div className="modal-content">
        <div className="modal-header mayusculas">
          <h3>Nuevo mensaje</h3>
        </div>
        <div className="modal-body mt-10">
          <p><strong>Para (DNI):</strong> {dni}</p>
          <textarea className="w-100 mt-10"
            placeholder="Escribe tu mensaje..."
            value={mensaje}
            onChange={(e) => setMensaje(e.target.value)}
          />
          <div className="botones flex gap-10 mt-10">
            <button className="boton" onClick={onClose}>Cancelar</button>
            <button className="boton" onClick={handleEnviar}>Enviar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NuevoMensaje;
